<template>
<v-card>
    <div class="pa-3" style="background: #3498db; color: white">
        <b>자산 설정</b>
    </div>

    <div v-if="assets.length > 0">
        <asset-item v-for="(asset, i) in assets" :key="`${asset.code}-${i}`" :index="i" :asset="asset" @set="$set(assets, i, $event)" @delete="assets.splice(i, 1)" />
    </div>

    <div class="pa-5 text-center" v-else>
        최소 1개의 자산이 필요합니다
    </div>

    <div class="pa-2 text-center">
        <v-btn rounded small color="primary" @click="addNewAsset">
            <v-icon>add</v-icon>
        </v-btn>
    </div>

    <v-divider />

    <v-row class="ma-2" align="center">
        <v-col class="py-0 my-0" offset="0" cols="12" offset-sm="9" sm="3">
            <v-text-field v-model="totalPercent" solo readonly :rules="percentRules" suffix="%" />
        </v-col>
    </v-row>
</v-card>
</template>

<script>
import {
    db,
    auth
} from '@/firebase'
import {
    DateFormat
} from '@/mixins/date.js'
import AssetItem from '@/views/components/AssetItem'
import ConditionDialog from '@/views/dialogs/ConditionDialog'
import { maxDate } from '@/constants'
import moment from 'moment'

export default {
    name: 'asset-board',
    components: {
        AssetItem,
        ConditionDialog
    },
    mixins: [
        DateFormat
    ],
    props: [
        'title'
    ],
    data() {
        return {
            assets: [{
                name: '삼성전자',
                code: '005930',
                sort: 'krstockprice',
                min: '2001-01-31',
                max: moment(maxDate).format('YYYY-MM-DD'),
                percent: 100
            }, ],
            percentRules: [v => v == 100 || '합이 100%여야 합니다', ]
        }
    },
    computed: {
        user() {
            return this.$store.getters.user
        },
        totalPercent() {
            if (this.assets.length == 0) return 0

            return this.assets.map(v => parseFloat(v.percent)).reduce((a, b) => a + b)
        }
    },
    created() {},
    async mounted() {},
    methods: {
        addNewAsset() {
            this.assets.push({
                name: '',
                code: '',
                min: '',
                max: '',
                percent: 0
            })
        },
        load(assets) {
            for (const asset of assets) {
                if (asset.sort == "krxstockprice") asset.sort = "krstockprice"
            }
            
            this.assets = assets
        },
        validate() {
            if (this.totalPercent != 100) {
                this.$toasted.error("합이 100%여야 합니다")
                return false
            }

            if (this.assets.filter(a => !a.name).length > 0) {
                this.$toasted.error("설정되지 않은 자산이 있습니다")
                return false
            }

            if (this.assets.filter(a => a.code != '000000').length < 1) {
                this.$toasted.error("현금 이외의 자산을 추가해야 합니다")
                return false
            }

            if (this.assets.filter(a => a.percent == 0).length > 0) {
                this.$toasted.error("비중이 0%인 자산이 있습니다")
                return false
            }

            return true
        },
    }
}
</script>
